import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const createAndDownloadAdditionalReleaseNote = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/create-and-download`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create and download additional release note", error);
    throw error;
  }
};

export const getAdditionalReleaseNoteLocations = async ({ jobId, username }) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/locations`,
      {
        params: {
          jobId,
          username,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch additional release note locations", error);
    throw error;
  }
};

export const getAllAdditionalReleaseNotes = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/all`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch additional release note history", error);
    throw error;
  }
};

export const searchAdditionalReleaseNotes = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/search/${jobId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to search additional release note history", error);
    throw error;
  }
};

export const checkAdditionalReleaseNoteConfig = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/check-customer-config/${jobId}/62`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to verify additional release note configuration", error);
    throw error;
  }
};

export const downloadAdditionalReleaseNote = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/additional/release-note/download`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to download additional release note", error);
    throw error;
  }
};